"use client";

import { c as _c } from "react/compiler-runtime";
import { Search } from "lucide-react";
import LinkButton from "@/components/ui/Link";
import { SubscriptionArea } from "./SubscriptionArea";
import { HeaderProfileDesktop } from "./HeaderProfileDesktop";
interface Props {
  isLoggedIn: boolean;
  displayName: string;
  hasActiveSubscription: boolean;
  daysLeft?: number;
}
export function HeaderDesktopRight(t0) {
  const $ = _c(11);
  const {
    isLoggedIn,
    displayName,
    hasActiveSubscription,
    daysLeft
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkButton href="/search" className="flex items-center h-10 w-10" variant="blur" size="none" title={"\u062C\u0633\u062A\u0648\u062C\u0648"}><Search size={18} /></LinkButton>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== daysLeft || $[2] !== hasActiveSubscription || $[3] !== isLoggedIn) {
    t2 = <SubscriptionArea isLoggedIn={isLoggedIn} hasActiveSubscription={hasActiveSubscription} daysLeft={daysLeft} />;
    $[1] = daysLeft;
    $[2] = hasActiveSubscription;
    $[3] = isLoggedIn;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== displayName || $[6] !== isLoggedIn) {
    t3 = <HeaderProfileDesktop isLoggedIn={isLoggedIn} displayName={displayName} />;
    $[5] = displayName;
    $[6] = isLoggedIn;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="hidden md:flex items-center gap-2">{t1}{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}